// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function MarkupHelpers$Container(props) {
  let __mobilePadding = props.mobilePadding;
  let mobilePadding = __mobilePadding !== undefined ? __mobilePadding : true;
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "w-full mx-auto md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]",
      mobilePadding ? "px-4" : "md:px-4",
      Stdlib_Option.getOr(props.className, "")
    ]),
    id: "container"
  });
}

let Container = {
  make: MarkupHelpers$Container
};

function MarkupHelpers$StandardLayout(props) {
  return JsxRuntime.jsx(MarkupHelpers$Container, {
    children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
      paddingFull: true,
      hasShadow: true,
      children: props.children
    })
  });
}

let StandardLayout = {
  make: MarkupHelpers$StandardLayout
};

let ContentBox;

exports.Container = Container;
exports.ContentBox = ContentBox;
exports.StandardLayout = StandardLayout;
/* tailwind-merge Not a pure module */
